import { getAppGlobals } from '~/components/AppGlobals/utils';

export const isStytchDfpEnabled = (): boolean => {
  const appGlobals = getAppGlobals();
  return !!appGlobals && appGlobals.VITE_STYTCH_DEVICE_FINGERPRINTING_ENABLED === 'true';
};

export const getStytchTelemetryId = async (): Promise<string | undefined> => {
  if (!isStytchDfpEnabled()) {
    return undefined;
  }

  const appGlobals = getAppGlobals();
  const publicToken = appGlobals.VITE_STYTCH_PUBLIC_TOKEN;
  if (!publicToken || typeof window.GetTelemetryID !== 'function') {
    return undefined;
  }

  const submitURL = appGlobals.VITE_STYTCH_SUBMIT_URL;

  try {
    return await window.GetTelemetryID(submitURL ? { publicToken, submitURL } : { publicToken });
  } catch {
    return undefined;
  }
};
